import { Button } from 'components/Button'
import { StrapiImage } from 'components/StapiImage'
import type { StrapiBanner } from 'types/strapi/banner'

type BannerProps = StrapiBanner

export function Banner({ link, image }: BannerProps) {
  if (!link?.title) return null

  return (
    <div className="flex items-center justify-center gap-4 bg-black px-4 py-3 text-center font-medium text-white md:flex-row md:space-y-0">
      {image ? (
        <>
          <StrapiImage
            {...image}
            quality={100}
            className="h-4 w-fit"
            height={80}
            width={80}
          />
          <span className="hidden text-white opacity-[0.24] md:block">|</span>
        </>
      ) : null}

      <Button href={link?.url} variant="raw" className="opacity-80">
        {link?.title}
      </Button>
    </div>
  )
}
